module.exports = require('./helpers/bundle-url').getBundleURL('kuLgW') + "bench.4a6cfd1f.png";